import React, { useState } from 'react'

import IconArrowRight from 'assets/images/icons/arr_right.svg'
import { ButtonIconSquare, CancelButton } from '@/modules/base/components/buttons'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import { ModalBig } from '@/modules/base/components/modal/index'

const VatPromptModalComponent = (props) => {
  const { title, description, okButtonLabel, cancelButtonLabel, onConfirm, onAbort, allowSaving } = props
  const classes = useStyles()
  const [state, setState] = useState({ surpress: false, open: true })

  const handleConfirmButtonClick = () => {
    setState({ ...state, open: false })
    onConfirm(state.surpress)
  }

  const handleCancelationButtonClick = () => {
    setState({ ...state, open: false })
    onAbort()
  }

  let actions = [
    <ButtonIconSquare key='save' icon={IconArrowRight} label={cancelButtonLabel} onClick={handleCancelationButtonClick} />,
  ]

  if (allowSaving === true) {
    actions = [
      <CancelButton key='cancel' label={cancelButtonLabel} onClick={handleCancelationButtonClick} />,
      <ButtonIconSquare key='save' icon={IconArrowRight} label={okButtonLabel} onClick={handleConfirmButtonClick} />,
    ]
  }

  return (
    <ModalBig
      open={state.open}
      actions={actions}
      title={title}>
      <div className={classes.content}>
        <p>{description}</p>
      </div>
    </ModalBig>
  )
}

const useStyles = makeStyles(() => {
  return {
    checkboxLabel: {
      marginLeft: '25px',
    },
    checkbox: {
      margin: '40px 0',
    },
    content: {
      paddingBottom: '15px',
    },

  }
})

VatPromptModalComponent.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  okButtonLabel: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
}

export default VatPromptModalComponent
